import { useRouter } from 'next/router';

import { useCallback } from 'react';

import { useAnalytics } from '@utils/analytics';
import { useMe } from '@utils/hook';
import { getPageNamespace } from '@utils/namespace';

export const useFirebase = () => {
  const router = useRouter();

  const { data: user } = useMe();
  const { firebase } = useAnalytics();

  const inflow = useCallback(
    (id: number, options?: { path?: string }) => {
      if (!user) {
        return;
      }
      firebase.logEvent('story_inflow', {
        storyId: id,
        userId: user.id,
        userCreated: user.created,
        path: options?.path ?? getPageNamespace(router),
      });
    },
    [router, user]
  );

  return { inflow };
};
